/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {useMemo} from "react";
import {useFetchServiceModel} from "./ServiceHooks";
import {service as UserService} from "../Services/UserService";

const defaultUserProfileImage = "/img/defaultProfilePicture.png";

export const useUserProfileImage = (providedUser) => {
    const { userId = null } = providedUser ?? {};
    
    // if the provided user does not have an image or orgImage
    // we will need to refetch the user model. This seems like it
    // maybe happens in some cases when the user session expired (?)
    if (!(providedUser?.image ?? providedUser?.orgImage)) {
        providedUser = null;
    }
    
    const user = useFetchServiceModel(UserService, userId, providedUser);
    
    return useMemo(() => {
        return user?.image ?? user?.orgImage ?? defaultUserProfileImage;
    }, [user?.userId, user?.image, user?.orgImage]);
}